import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=11b820c8"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=11b820c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports